export default "__VITE_ASSET__BTXD2SSM__"